import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";

@Component({
  selector: 'app-edit-form',
  templateUrl: './edit-form.component.html',
  styleUrls: ['./edit-form.component.scss']
})
export class EditFormComponent {
  prefillData: any;
  formData = [];
  totalCount = 1;
  isLoading = false;
  country = '';
  @ViewChild('failedDialog') failedCall!: TemplateRef<any>;
  editBookingData: any;
  requiredHtml = '';

  constructor(private storage: StorageService, private apiService: ApiService, public dialog: MatDialog, private router: Router, private spinner: NgxSpinnerService) {

  }

  async submitForm(event: any) {
    this.spinner.show();
    if (event.length > 0) {
      event[0].form_id = this.prefillData.form_id.toString();
      let submitData = {
        "applicant_id": this.prefillData.id,
        "applicants": event[0]
      };
      await this.apiService.updateApplication(submitData).then(
        (data: any) => {
          this.spinner.hide();
          if (data["success"]) {
            this.router.navigate(['/form-success'], { replaceUrl: true });
          } else {
            this.showFailedDialog();
            this.spinner.hide();
          }
        },
        (error: any) => {
          this.spinner.hide();
          this.showFailedDialog();
        }
      );
    }

  };

  showFailedDialog() {
    let dialogRef = this.dialog.open(this.failedCall, { disableClose: true });
    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        if (result === 'yes') {
        } else if (result === 'no') {
        }
      }
    });
  }

  ngOnInit() {
    let data = JSON.parse(this.storage.get('form_data') || '[]');
    this.requiredHtml = data?.data?.entity_details[0].custom_text;
    this.country = data?.data?.title;
    this.prefillData = JSON.parse(this.storage.get('prefill_data') || '[]');
    this.formData = data?.data?.elements;
  }

}
